import { useContext, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { SmartContext } from '../../../library/Core/SmartContext';
import { Tooltip } from 'bootstrap';
import { getStudentImage } from '../../../common/styles/Images';
import InitialsAvatar from '../../../library/SimpleControls/InitialsAvatar';
import { allowPerformAction, canSendDirectoryMessage, displayActionNotAllowedAlert, formatFullName, getActionElementClass, getDirectorySendDisabledTooltip, getWhiteLabelUrl, isEmpty } from '../../../library/Core/SmartFunctions';
import SessionContext from '../../../library/Core/SessionContext';
import GetStartedPromptModal from './GetStartedPromptModal';
import RecruiterCardWorking from './RecruiterCardWorking';
import { useNavigate, useParams } from 'react-router-dom';

const RecruiterCardGridControl = () => {
    const { state } = useContext(SmartContext);
    const { sessionState } = useContext(SessionContext);
    const { type } = useParams();

    const students = state.data.students;
    const [displayedStudents, setDisplayedStudents] = useState(students?.slice(0, 20));
    const [hasMore, setHasMore] = useState(displayedStudents.length < students.length);
    const urlParams = new URLSearchParams(window.location.search);
    const templateId = urlParams.get('template_id');
    const temp_id = urlParams.get('temp_ref_id');
    const fetchMoreStudents = () => {
        if (displayedStudents.length >= students.length) {
            setHasMore(false);
            return;
        }

        const startIndex = displayedStudents.length;
        const endIndex = startIndex + 20;
        const newDisplayedStudents = students.slice(startIndex, endIndex);
        setDisplayedStudents((prevStudents: any) => [...prevStudents, ...newDisplayedStudents]);
    };

    useEffect(() => {
        // Initialize tooltips when the component mounts
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('.btn-white-tooltip'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl, {
                // customClass: 'tooltip-white'
            });
        });

        return () => {
            tooltipList.forEach((tooltip) => tooltip.dispose());
        };
    }, [displayedStudents, state?.data?.cardViewMode]);

    useEffect(() => {
        setDisplayedStudents(students?.slice(0, 20));
        if (students?.length > 20) {
            setHasMore(true);
        }
    }, [students]);

    const noRecordsFound = () => (
        <div className="row g-2 g-md-4 alumni-showcase" id="FilterData">
            <div className="no_listed_items_blk">
                <div className="mt-0">
                    <div className="max-470 mx-auto">
                        <img
                            className="mt-2 mb-4 float_horizontal_animate"
                            src={`${process.env.REACT_APP_IMAGE_BASEPATH}/alumni_directory_nodata.svg`}
                        />
                        <p className="font-18 font-400 mb-4 text-center">
                            Looks like no alumni matching your search criteria has an active account yet!
                        </p>
                        {sessionStorage.getItem('user-type-code') == 'ALUMNI' && (
                            <div>
                                <p className="font-18 font-400 mb-4 text-center">
                                    Don’t worry! You can send invites to them and have them activate their profile on the network.
                                </p>
                                <div className="xscroll">
                                    <div className="d-block text-center mx-5 px-5">
                                        <a href="/alumni-invite/peer" className="btn-green height-40 text-white me-2">
                                            <span>Send Invite !</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );

    const studentProfileLink = (uuid: string) => {
        const link = `/alumni/${uuid}/profile`;
        return link;
    };

    const handleNoImg = () => {
        return `${process.env.REACT_APP_IMAGE_BASEPATH}/no_university_img.svg`;
    };

    const geAlumniName = (student: any) => {
        return `<div class="alumni_univarsity_brife">
                    <div class="alumni_univarsity_subject">
                        <span class="text-black">${formatFullName(student.firstName, student.lastName)}</span>
                    </div>
                </div>`;
    };

    if (localStorage.getItem('isEmailVerified') == 'undefined') {
        localStorage.removeItem('isEmailVerified');
        sessionStorage.removeItem('isEmailVerified');
    }

    const isEmailVerified: number = localStorage.getItem('isEmailVerified') ? Number(localStorage.getItem('isEmailVerified')) : 1;

    const showStar = (row: any) => (row.isNotable && row.isNotable == 1 ? true : false);

    // here broadcast functions
    const navigate = useNavigate();

    const [selectedBroadcastRecruiterIds, setSelectedIds] = useState<string[]>([]);
    const [selectAll, setSelectAll] = useState(false);

    const handleSelectAll = () => {
        if (!selectAll) {
            const allIds = displayedStudents.map((s: any) => s.uuid);
            setSelectedIds(allIds);
        } else {
            setSelectedIds([]);
        }
        setSelectAll(!selectAll);
    };

    const handleCheckboxToggle = (uuid: string) => {
        setSelectedIds((prev) => (prev.includes(uuid) ? prev.filter((id) => id !== uuid) : [...prev, uuid]));
    };

    const handleNext = () => {
    if (selectedBroadcastRecruiterIds.length === 0) {
        alert('Select at least one alumni');
        return;
    }

    // convert array -> string for sessionStorage
    const studentDataForEmail = JSON.stringify(selectedBroadcastRecruiterIds);

    console.log('student_data_for_email', studentDataForEmail);

    if (temp_id) {
        sessionStorage.setItem('student_data_for_email', studentDataForEmail);
        navigate(`/broadcast/templatepreview?template_id=${templateId}&temp_id=${temp_id}`, {
            state: { student_data_for_email: selectedBroadcastRecruiterIds },
        });
    } else {
        sessionStorage.setItem('student_data_for_email', studentDataForEmail);
        navigate(`/broadcast/emailpreview?template_id=${templateId}`, {
            state: { student_data_for_email: selectedBroadcastRecruiterIds },
        });
    }
};


    return (
        <section className="alumni_directory_details bg-white container-fluid">
            <div className="max-1140 pt-4 pb-5 mx-auto">
                <div className="row g-3 align-items-center mb-4">
                    {type === 'broadcast' && (
                        <>
                            <div className="col-auto">
                                {/* <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                <label className="form-check-label" htmlFor="flexCheckDefault">
                                    Select All
                                </label>
                                </div> */}
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="flexCheckDefault"
                                        checked={selectAll}
                                        onChange={handleSelectAll}
                                    />
                                    <label className="form-check-label" htmlFor="flexCheckDefault">
                                        Select All
                                    </label>
                                </div>
                            </div>
                            <div className="col text-center">
                                <button type="button" onClick={handleNext} className="btn btn-dark-blue text-white height-40 px-5 mx-auto">
                                    <span>Next</span>
                                </button>
                            </div>
                            {/* <div className="col text-center">
                                <a href="create-broadcast-step-4.html" className="btn btn-dark-blue text-white height-40 px-5 mx-auto text-decoration-none"><span>Next</span></a>
                            </div> */}
                        </>
                    )}
                    <div className="col-auto">
                        <div className="alumni_count mt-0">{state?.data?.students?.length ?? 0} Alumni Found</div>
                    </div>
                </div>
                {
                    <InfiniteScroll dataLength={displayedStudents.length} next={fetchMoreStudents} hasMore={hasMore} loader={''}>
                        <div className="overflow-hidden">
                            <div className="row g-2 g-md-4 alumni-showcase">
                                {displayedStudents?.length > 0 &&
                                    displayedStudents?.map((student: any) => {
                                        return (
                                            <div key={student.uuid + ' ' + student.programId} className="col-lg-4 col-md-6 col-sm-6 Dusers">
                                                <div className="alumni-bucket">
                                                    {type === 'broadcast' && (
                                                        <div className="form-check mb-2">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={selectedBroadcastRecruiterIds.includes(student.uuid)}
                                                                onChange={() => handleCheckboxToggle(student.uuid)}
                                                            />
                                                        </div>
                                                    )}
                                                    <div className="alumni_class_link">
                                                        <div className="alumni_name_detail">
                                                            <div className="alumni_img overflow-visible">
                                                                <a
                                                                    className="alumni_img_link d-flex"
                                                                    target="_blank"
                                                                    href={studentProfileLink(student.uuid)}
                                                                    rel="noreferrer">
                                                                    <i className="position-relative">
                                                                        {student.profilePictureFilePath ? (
                                                                            <img
                                                                                className="img-fluid"
                                                                                src={getStudentImage(student)}
                                                                                alt={`${formatFullName(student.firstName, student.lastName)}`}
                                                                            />
                                                                        ) : (
                                                                            <InitialsAvatar firstName={student.firstName} lastName={student.lastName} />
                                                                        )}
                                                                        {showStar(student) && <i className="icon-star circle-img"></i>}
                                                                    </i>
                                                                </a>
                                                            </div>
                                                            <div className="alumni_name_brife">
                                                                <h3>
                                                                    <a
                                                                        className="btn-white-tooltip sss"
                                                                        href={studentProfileLink(student.uuid)}
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-html="true"
                                                                        title={`${formatFullName(student.firstName, student.lastName)}`}
                                                                        target="_blank">
                                                                        {`${formatFullName(student.firstName, student.lastName)}`}
                                                                    </a>
                                                                </h3>
                                                                <span className="alumni_campus">
                                                                    {student?.programName}, {student?.passOutYear}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="send_link d-flex align-items-center">
                                                            {isEmailVerified == 1 && canSendDirectoryMessage(student) ? (
                                                                <GetStartedPromptModal
                                                                    loginId={sessionState?.id}
                                                                    userTypeCode={sessionState?.userTypeCode}
                                                                    name={`${sessionState?.firstName} ${sessionState?.lastName}`}
                                                                    programId={sessionState?.institutes?.[0]?.programId}
                                                                    student={student}
                                                                    className={`btn-send ${getActionElementClass()}`}
                                                                    imgWidth={506}
                                                                />
                                                            ) : (
                                                                <a
                                                                    href="javascript:;"
                                                                    className={`btn-send btn-white-tooltip ${getActionElementClass()}`}
                                                                    style={{ background: 'grey' }}
                                                                    data-bs-toggle="tooltip"
                                                                    data-bs-html="true"
                                                                    data-bs-original-title={getDirectorySendDisabledTooltip(isEmailVerified, student)}>
                                                                    <i className="icon-alumni-send"></i>
                                                                    <span>Send</span>
                                                                </a>
                                                            )}
                                                            {student?.badges === 1 ? (
                                                                <a
                                                                    href="javascript:void(0)"
                                                                    className="btn-monitor ms-2 btn-white-tooltip"
                                                                    data-bs-toggle="tooltip"
                                                                    data-bs-html="true"
                                                                    data-bs-original-title="Mentor Badge">
                                                                    <i className="icon-multiple-users"></i>
                                                                </a>
                                                            ) : null}
                                                        </div>

                                                        <div className="verify_massrecruiter">
                                                            <ul>
                                                                {!isEmpty(student?.recruiterMobileNumber) &&
                                                                    !isEmpty(student?.recruiterEmail) && (
                                                                        <li>
                                                                            <i className="verify"></i> <span>Confirmed</span>
                                                                        </li>
                                                                    )}
                                                                {student?.numberOfOffers && (
                                                                    <>
                                                                        {student.numberOfOffers
                                                                            .split(',')
                                                                            .some((offer: any) => offer.trim() === '>10') ? (
                                                                            <li>
                                                                                <i className="massrecruiter"></i>{' '}
                                                                                <span>Mass Recruiter</span>
                                                                            </li>
                                                                        ) : student.numberOfOffers
                                                                              .split(',')
                                                                              .some((offer: any) =>
                                                                                  ['<5', '5_10'].includes(offer.trim())
                                                                              ) ? (
                                                                            <li>
                                                                                <i className="massrecruiter"></i>{' '}
                                                                                <span>Niche Recruiter</span>
                                                                            </li>
                                                                        ) : null}
                                                                    </>
                                                                )}
                                                            </ul>
                                                        </div>

                                                        {student.recruiterProfile === 'POTENTIAL_RECRUITER' &&
                                                            (isEmpty(student?.recruiterMobileNumber) ||
                                                                isEmpty(student?.recruiterEmail)) && (
                                                                <div className="verify_massrecruiter pt-3">
                                                                    <a
                                                                        className={`confirmRecruiter text-decoration-none text-dark-blue ${getActionElementClass()}`}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                        href={`/alumni/${student.uuid}/recruiter-basic-info`}
                                                                        onClick={(e) => {
                                                                            if (!allowPerformAction()) {
                                                                                e.preventDefault();
                                                                                displayActionNotAllowedAlert();
                                                                            }
                                                                        }}>
                                                                        Confirm Recruiter
                                                                    </a>
                                                                </div>
                                                            )}
                                                    </div>
                                                    <RecruiterCardWorking alumni={student} state={state} />
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    </InfiniteScroll>
                }

                {!state?.flags.isDataLoading && students.length === 0 && noRecordsFound()}
            </div>
        </section>
    );
};

export default RecruiterCardGridControl;
